import React from "react";
import { Router, Routes, Route, Loadable } from "@discoverr/web/Router";
import { Bootstrap } from "@discoverr/web/Bootstrap";
import { SpaceAuthLoginPage } from "@discoverr/web/SpaceAuth";
import dateFnsLocale from "date-fns/locale/da";
import da from "@discoverr/web/languages/da";
import { useNavigate } from "@discoverr/web/Router";

// Views
const LoadableApp = Loadable(React.lazy(() => import("./views/App")));

// Components
const Login = () => {
  const navigate = useNavigate();
  return (
    <SpaceAuthLoginPage
      title="Eagle Eyes"
      subtitle="Medlemsportal"
      image="https://imboxprotection.com/media/3ekgm2lj/imboxprotection-flagship.png"
      onSuccess={() => {
        navigate("/");
      }}
    />
  );
};

//
export const Root = () => {
  return (
    <Bootstrap
      titleTemplate="Eagle Eyes - %s"
      language={da}
      art={true}
      artConfig={{ primary: "#e63946" }}
      dateFnsLocale={dateFnsLocale}
    >
      <Router>
        <Routes>
          <Route path="/auth/login" element={<Login />} />
          <Route path="/*" element={<LoadableApp />} />
        </Routes>
      </Router>
    </Bootstrap>
  );
};
